// Utility functions related to loading image blob data
import { MODULE_COMMONS_REGION_SYMBOL_KEY, Region } from "../Constants";
import { getAppWideSingleton } from "../singleton/Singleton";
export const ITEM_IMAGE_PARAM = {
    // Domain hardcoded according to https://w.amazon.com/index.php/MSA/HowTo/UsingCorrectImageDomains.
    // TODO: This domain is for NA/EU/FE, add CN support config.
    ITEM_IMAGE_DOMAIN: 'https://m.media-amazon.com/images/I/',
    ITEM_IMAGE_DOMAIN_CN: 'https://images-cn.ssl-images-amazon.cn/images/I/',
    // Mock up https://opie.invisionapp.com/share/TEEYWAEW6Q8#/screens
    // Image should be 80px * 80px
    ITEM_IMAGE_SIZE: '_AA80_',
    // https://issues.amazon.com/issues/ADS-8430
    NO_IMAGE_PHYSICAL_ID: '01RmK+J4pJL',
    NO_IMAGE_EXTENSION: 'gif',
};
/**
 * Utility function to fetch image blob data from URL
 * @param url {string} - full url to fetch image
 * @return Promise<string> - Promise of blob string of image.
 */
export function fetchImageBlob(url) {
    const request = new Request(url);
    return fetch(request)
        .then((response) => {
        if (response.ok) {
            return response.blob();
        }
        else {
            throw new Error('Error fetching image, status ' + response.status);
        }
    })
        .then((blob) => {
        return URL.createObjectURL(blob);
    })
        .catch((error) => {
        console.warn('Error fetching image ' + url, error);
        return '';
    });
}
export function buildItemImageUrl(imagePhysicalId, imageExtension, appRegion) {
    let extension = ITEM_IMAGE_PARAM.NO_IMAGE_EXTENSION;
    let physicalId = ITEM_IMAGE_PARAM.NO_IMAGE_PHYSICAL_ID;
    const regionForImageDomain = appRegion || getAppWideSingleton(MODULE_COMMONS_REGION_SYMBOL_KEY); // either use region passed in or the singleton value if it exists in the context.
    const imageDomain = regionForImageDomain === Region.CN ? ITEM_IMAGE_PARAM.ITEM_IMAGE_DOMAIN_CN : ITEM_IMAGE_PARAM.ITEM_IMAGE_DOMAIN;
    if (imageExtension && imagePhysicalId) {
        extension = imageExtension;
        physicalId = imagePhysicalId;
    }
    return (imageDomain +
        physicalId +
        '.' +
        ITEM_IMAGE_PARAM.ITEM_IMAGE_SIZE +
        '.' +
        extension);
}
//# sourceMappingURL=ImageUtils.js.map